// About Us — Returns Trust Strip (all product PDPs) — 2026-06-21
// Injects a slim "30-day returns" strip below the ATC button on every
// /products/* page. Gateway for the returns portal as a trust signal.
//
// Brand guardrails: no urgency/FOMO, no discount language, navy #131936 /
// milk #F4F1EA, Raleway body font, Unbounded display font.
//
// Idempotent — guards on window.__auReturnsTrustLoaded + element ID check.
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (!/\/products\//.test(location.pathname)) return;
  if (window.__auReturnsTrustLoaded) return;
  window.__auReturnsTrustLoaded = true;

  var BRAND_NAVY = '#131936';
  var FONT_BODY = "'Raleway', 'Helvetica Neue', sans-serif";

  var style = document.createElement('style');
  style.textContent = [
    '.au-returns-strip{',
      'display:flex;align-items:flex-start;gap:10px;',
      'padding:14px 0;',
      'border-top:1px solid rgba(19,25,54,0.1);',
      'margin-top:16px;',
    '}',
    '.au-returns-strip__checkmarks{',
      'display:flex;flex-direction:column;gap:5px;flex:1;',
    '}',
    '.au-returns-strip__item{',
      'display:flex;align-items:center;gap:7px;',
    '}',
    '.au-returns-strip__tick{',
      'font-size:13px;color:' + BRAND_NAVY + ';',
      'flex-shrink:0;line-height:1;',
    '}',
    '.au-returns-strip__label{',
      'font-family:' + FONT_BODY + ';',
      'font-size:13px;color:rgba(19,25,54,0.72);',
      'line-height:1.4;margin:0;',
    '}',
    '.au-returns-strip__link{',
      'color:' + BRAND_NAVY + ';',
      'text-decoration:underline;',
      'text-underline-offset:2px;',
      'font-weight:600;',
    '}',
    '.au-returns-strip__link:hover{opacity:0.7;}',
  ].join('');
  document.head.appendChild(style);

  function qs(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function inject() {
    if (document.getElementById('au-returns-strip')) return;

    // Find the ATC button
    var atcBtn = qs([
      'button[name="add"]',
      '.product-form__submit',
      '[data-testid="Checkout-button"]',
      'form[action*="/cart/add"] button[type="submit"]',
      '.btn--add-to-cart',
    ]);
    if (!atcBtn) return;

    // Walk up to a sensible container
    var atcContainer = atcBtn.closest([
      '.product-form__buttons',
      '.product-form__cart',
      '[class*="buy-buttons"]',
      'form[action*="/cart/add"]',
    ].join(',')) || atcBtn.parentElement;
    if (!atcContainer || !atcContainer.parentElement) return;

    var strip = document.createElement('div');
    strip.id = 'au-returns-strip';
    strip.className = 'au-returns-strip';
    strip.innerHTML =
      '<div class="au-returns-strip__checkmarks">' +
        '<div class="au-returns-strip__item">' +
          '<span class="au-returns-strip__tick">&#x2713;</span>' +
          '<p class="au-returns-strip__label">Free shipping Australia-wide</p>' +
        '</div>' +
        '<div class="au-returns-strip__item">' +
          '<span class="au-returns-strip__tick">&#x2713;</span>' +
          '<p class="au-returns-strip__label">30-day returns &mdash; ' +
            '<a class="au-returns-strip__link" href="/returns">start a return</a>' +
          '</p>' +
        '</div>' +
      '</div>';

    atcContainer.parentElement.insertBefore(strip, atcContainer.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
